import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * A simple global warn-once helper.
 *
 * Why:
 * - Some warnings need to fire before a hub/client/server instance exists (e.g. api factory functions).
 * - We use Symbol.for() so multiple bundles/versions can share the same dedupe storage.
 */

var WARN_ONCE_SYMBOL = Symbol.for('__requestIframeWarnOnce__');
function getHost() {
  if (typeof window !== 'undefined') return window;
  return globalThis;
}
function getWarnOnceSet() {
  var host = getHost();
  if (!(WARN_ONCE_SYMBOL in host)) {
    host[WARN_ONCE_SYMBOL] = new Set();
  }
  return host[WARN_ONCE_SYMBOL];
}
export function warnOnce(key, fn) {
  var set = getWarnOnceSet();
  if (set.has(key)) return;
  set.add(key);
  fn();
}